var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPileOfPoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0971 15.5726C21.0628 11.9441 16.9542 11.1784 16.9542 11.1784C18.1199 7.54979 14.4914 7.20122 14.4914 7.20122C14.9656 5.77836 12.0114 4.25264 12.3942 3.36693C12.5314 3.02979 12.3314 3.02979 12.3314 3.02979C9.41707 4.06979 8.81707 6.46979 8.79993 7.53836C8.79422 7.8355 6.1885 7.80693 6.40564 11.1841C6.41707 11.3555 6.35422 11.5098 6.19422 11.5784C4.27993 12.3841 4.19993 14.6698 4.52564 15.4069C4.52564 15.4069 4.61136 15.4012 4.48564 15.4126C2.84564 15.5669 2.28564 16.9441 2.28564 18.0526C2.28564 19.2184 3.08564 20.9726 5.41707 20.9726C6.7085 20.9726 7.56564 20.7555 10.6171 20.7555C13.6685 20.7555 14.7085 20.9726 18.5828 20.9726C18.9428 20.9726 18.8228 20.9726 19.0914 20.9726C19.8171 20.9726 21.7085 20.3155 21.7085 18.4926C21.7085 16.6698 19.9656 15.5726 19.0971 15.5726Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0971 15.5726C21.0628 11.9441 16.9542 11.1784 16.9542 11.1784C18.1199 7.54979 14.4914 7.20122 14.4914 7.20122C14.9656 5.77836 12.0114 4.25264 12.3942 3.36693C12.5314 3.02979 12.3314 3.02979 12.3314 3.02979C9.41707 4.06979 8.81707 6.46979 8.79993 7.53836C8.79422 7.8355 6.1885 7.80693 6.40564 11.1841C6.41707 11.3555 6.35422 11.5098 6.19422 11.5784C4.27993 12.3841 4.19993 14.6698 4.52564 15.4069C4.52564 15.4069 4.61136 15.4012 4.48564 15.4126C2.84564 15.5669 2.28564 16.9441 2.28564 18.0526C2.28564 19.2184 3.08564 20.9726 5.41707 20.9726C6.7085 20.9726 7.56564 20.7555 10.6171 20.7555C13.6685 20.7555 14.7085 20.9726 18.5828 20.9726C18.9428 20.9726 18.8228 20.9726 19.0914 20.9726C19.8171 20.9726 21.7085 20.3155 21.7085 18.4926C21.7085 16.6698 19.9656 15.5726 19.0971 15.5726Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9543 11.1774C18.12 7.54885 14.4915 7.20028 14.4915 7.20028C14.9658 5.77742 12.08 4.326 12.3943 3.36599C12.5086 3.01742 12.3315 3.02885 12.3315 3.02885C9.41719 4.06885 8.81719 6.46885 8.80005 7.53742C8.79433 7.83457 6.18862 7.806 6.40576 11.1831C6.41719 11.3546 6.36005 11.5203 6.19434 11.5774C8.32005 11.5774 9.26862 16.2974 19.0915 15.566C21.0115 11.7946 16.9543 11.1774 16.9543 11.1774Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9543 11.1774C18.12 7.54885 14.4915 7.20028 14.4915 7.20028C14.9658 5.77742 12.08 4.326 12.3943 3.36599C12.5086 3.01742 12.3315 3.02885 12.3315 3.02885C9.41719 4.06885 8.81719 6.46885 8.80005 7.53742C8.79433 7.83457 6.18862 7.806 6.40576 11.1831C6.41719 11.3546 6.36005 11.5203 6.19434 11.5774C8.32005 11.5774 9.26862 16.2974 19.0915 15.566C21.0115 11.7946 16.9543 11.1774 16.9543 11.1774Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4914 7.20024C14.9657 5.77739 12.0572 4.3031 12.3943 3.36596C12.5143 3.0231 12.3314 3.02881 12.3314 3.02881C9.41715 4.06881 8.81715 6.46881 8.80001 7.53739C8.80001 7.53739 8.49144 11.1145 16.9543 11.1774C18.12 7.54881 14.4914 7.20024 14.4914 7.20024Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6171 20.7548C13.6742 20.7548 14.7085 20.972 18.5828 20.972C8.54279 20.972 6.33707 15.4062 4.52564 15.4062C4.52564 15.4062 4.51993 15.4062 4.52564 15.4062C2.75993 15.6005 2.28564 17.0177 2.28564 18.052C2.28564 19.2177 3.08564 20.972 5.41707 20.972C6.7085 20.972 7.55993 20.7548 10.6171 20.7548Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6743 4.97168C9.00001 5.93168 8.80572 6.94311 8.80001 7.53739C8.80001 7.53739 8.49144 11.1145 16.9543 11.1774C10.3886 10.7774 8.42858 7.74311 9.6743 4.97168Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0971 15.5714C19.4 14.9828 19.5485 14.4685 19.5942 14.0228C19.0971 15.5714 14.8114 15.6628 11.3085 14.2571C8.18852 13.0057 6.62852 11.2857 6.44567 10.1143C6.39995 10.4285 6.38281 10.7828 6.41138 11.1885C6.42281 11.36 6.36567 11.5257 6.19995 11.5828C7.79424 11.7371 9.26852 16.2971 19.0971 15.5714Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4458 15.4177C4.47437 15.412 4.50294 15.412 4.5258 15.4063C4.51437 15.4063 4.50294 15.4062 4.49152 15.412C4.47437 15.412 4.45723 15.4177 4.4458 15.4177Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.4914 7.20024C14.9657 5.77739 12.0572 4.3031 12.3943 3.36596C12.5143 3.0231 12.3314 3.02881 12.3314 3.02881C9.41715 4.06881 8.81715 6.46881 8.80001 7.53739C8.80001 7.53739 8.49144 11.1145 16.9543 11.1774C18.12 7.54881 14.4914 7.20024 14.4914 7.20024Z",
    fill: "url(#paint9_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.4914 7.20024C14.9657 5.77739 12.0572 4.3031 12.3943 3.36596C12.5143 3.0231 12.3314 3.02881 12.3314 3.02881C9.41715 4.06881 8.81715 6.46881 8.80001 7.53739C8.80001 7.53739 8.49144 11.1145 16.9543 11.1774C18.12 7.54881 14.4914 7.20024 14.4914 7.20024Z",
    fill: "url(#paint10_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0342 6.00598C12.52 7.07455 14.4914 7.20027 14.4914 7.20027C14.9142 5.93741 12.6742 4.63455 12.3942 3.70312C12.4 3.70312 11.5828 5.00598 12.0342 6.00598Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0342 6.00598C12.52 7.07455 14.4914 7.20027 14.4914 7.20027C14.9142 5.93741 12.6742 4.63455 12.3942 3.70312C12.4 3.70312 11.5828 5.00598 12.0342 6.00598Z",
    fill: "url(#paint12_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.9543 11.1771C8.49719 11.1143 8.80005 7.53711 8.80005 7.53711C8.79433 7.83425 6.18862 7.80568 6.40576 11.1828C6.41719 11.3543 6.36005 11.52 6.19434 11.5771C8.32005 11.5771 9.26862 16.2971 19.0915 15.5657C21.0115 11.7943 16.9543 11.1771 16.9543 11.1771Z",
    fill: "url(#paint13_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41138 11.1831C6.42281 11.3545 6.35995 11.5088 6.19995 11.5774C6.35995 11.5202 6.42281 11.3545 6.41138 11.1831Z",
    fill: "url(#paint14_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.0971 15.5716C9.27422 16.303 8.32564 11.583 6.19993 11.583C4.28564 12.3887 4.20564 14.6744 4.53136 15.4116C4.53136 15.4116 4.61707 15.4059 4.49136 15.4173C2.84564 15.5659 2.28564 16.943 2.28564 18.0516C2.28564 19.2173 3.08564 20.9716 5.41707 20.9716C6.7085 20.9716 7.56564 20.7544 10.6171 20.7544C13.6685 20.7544 14.7085 20.9716 18.5828 20.9716C18.9428 20.9716 18.8228 20.9716 19.0914 20.9716C19.8171 20.9716 21.7085 20.3144 21.7085 18.4916C21.7085 16.6687 19.9656 15.5716 19.0971 15.5716Z",
    fill: "url(#paint15_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6171 20.7548C13.6742 20.7548 14.7085 20.972 18.5828 20.972C8.54279 20.972 6.33707 15.4062 4.52564 15.4062C4.52564 15.4062 4.51993 15.4062 4.52564 15.4062C2.75993 15.6005 2.28564 17.0177 2.28564 18.052C2.28564 19.2177 3.08564 20.972 5.41707 20.972C6.7085 20.972 7.55993 20.7548 10.6171 20.7548Z",
    fill: "url(#paint16_radial)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M10.6171 20.7548C13.6742 20.7548 14.7085 20.972 18.5828 20.972C8.54279 20.972 6.33707 15.4062 4.52564 15.4062C4.52564 15.4062 4.51993 15.4062 4.52564 15.4062C2.75993 15.6005 2.28564 17.0177 2.28564 18.052C2.28564 19.2177 3.08564 20.972 5.41707 20.972C6.7085 20.972 7.55993 20.7548 10.6171 20.7548Z",
    fill: "url(#paint17_radial)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M19.0971 15.5716C9.27422 16.303 8.32564 11.583 6.19993 11.583C4.28564 12.3887 4.20564 14.6744 4.53136 15.4116C4.53136 15.4116 4.61707 15.4059 4.49136 15.4173C2.84564 15.5659 2.28564 16.943 2.28564 18.0516C2.28564 19.2173 3.08564 20.9716 5.41707 20.9716C6.7085 20.9716 7.56564 20.7544 10.6171 20.7544C13.6685 20.7544 14.7085 20.9716 18.5828 20.9716C18.9428 20.9716 18.8228 20.9716 19.0914 20.9716C19.8171 20.9716 21.7085 20.3144 21.7085 18.4916C21.7085 16.6687 19.9656 15.5716 19.0971 15.5716Z",
    fill: "url(#paint18_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M12.7427 12.1661C12.7427 13.4175 13.6684 14.429 14.8112 14.429C15.9541 14.429 16.8798 13.4175 16.8798 12.1661C16.8798 10.9147 15.9541 10.0347 14.8112 10.0347C13.6684 10.0347 12.7427 10.9147 12.7427 12.1661Z",
    fill: "url(#paint19_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M12.7427 12.4519C12.7427 13.7034 13.6684 14.7148 14.8112 14.7148C15.9541 14.7148 16.8798 13.7034 16.8798 12.4519C16.8798 11.2005 15.9541 10.3662 14.8112 10.3662C13.6684 10.3662 12.7427 11.2005 12.7427 12.4519Z",
    fill: "url(#paint20_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M7.11426 12.1661C7.11426 13.4175 8.03997 14.429 9.18283 14.429C10.3257 14.429 11.2514 13.4175 11.2514 12.1661C11.2514 10.9147 10.3257 10.0347 9.18283 10.0347C8.03997 10.0347 7.11426 10.9147 7.11426 12.1661Z",
    fill: "url(#paint21_radial)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M7.11426 12.4519C7.11426 13.7034 8.03997 14.7148 9.18283 14.7148C10.3257 14.7148 11.2514 13.7034 11.2514 12.4519C11.2514 11.2005 10.3257 10.3662 9.18283 10.3662C8.03997 10.3662 7.11426 11.2005 7.11426 12.4519Z",
    fill: "url(#paint22_radial)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 14.4291C15.9595 14.4291 16.8857 13.503 16.8857 12.3606C16.8857 11.2181 15.9595 10.292 14.8171 10.292C13.6747 10.292 12.7485 11.2181 12.7485 12.3606C12.7485 13.503 13.6747 14.4291 14.8171 14.4291Z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8354 13.9807C16.7307 13.4183 17.0006 12.2367 16.4382 11.3414C15.8759 10.4462 14.6943 10.1763 13.799 10.7386C12.9037 11.301 12.6338 12.4826 13.1962 13.3779C13.7585 14.2731 14.9402 14.543 15.8354 13.9807Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 14.2749C15.8743 14.2749 16.7314 13.4178 16.7314 12.3606C16.7314 11.3033 15.8743 10.4463 14.8171 10.4463C13.7599 10.4463 12.9028 11.3033 12.9028 12.3606C12.9028 13.4178 13.7599 14.2749 14.8171 14.2749Z",
    fill: "url(#paint24_radial)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 14.2749C15.8743 14.2749 16.7314 13.4178 16.7314 12.3606C16.7314 11.3033 15.8743 10.4463 14.8171 10.4463C13.7599 10.4463 12.9028 11.3033 12.9028 12.3606C12.9028 13.4178 13.7599 14.2749 14.8171 14.2749Z",
    fill: "url(#paint25_radial)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8171 14.4291C15.9595 14.4291 16.8857 13.503 16.8857 12.3606C16.8857 11.2181 15.9595 10.292 14.8171 10.292C13.6747 10.292 12.7485 11.2181 12.7485 12.3606C12.7485 13.503 13.6747 14.4291 14.8171 14.4291Z",
    fill: "url(#paint26_radial)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.817 13.3092C15.3409 13.3092 15.7656 12.8846 15.7656 12.3607C15.7656 11.8368 15.3409 11.4121 14.817 11.4121C14.2931 11.4121 13.8684 11.8368 13.8684 12.3607C13.8684 12.8846 14.2931 13.3092 14.817 13.3092Z",
    fill: "url(#paint27_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.817 13.0175C15.1884 13.0175 15.5255 12.8461 15.737 12.5718C15.6398 12.9946 15.2627 13.3089 14.817 13.3089C14.3655 13.3089 13.9884 12.9946 13.897 12.5718C14.1084 12.8403 14.4398 13.0175 14.817 13.0175Z",
    fill: "url(#paint28_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18.3947C9.36564 18.3947 8.52564 15.5719 9.32564 16.0119C10.3999 16.6062 11.0856 16.6633 11.9999 16.6633C12.9142 16.6633 13.5942 16.6062 14.6742 16.0119C15.4742 15.5719 14.6342 18.3947 11.9999 18.3947Z",
    fill: "url(#paint29_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6743 16.0117C13.6 16.606 12.9143 16.6631 12 16.6631C11.0858 16.6631 10.4058 16.606 9.32576 16.0117C9.04576 15.8574 8.96576 16.0974 9.09147 16.4803C9.09147 16.4746 9.13147 16.0631 9.50862 16.3489C9.50862 16.3489 10.8972 17.1831 11.9943 17.1831C13.0915 17.1831 14.48 16.3489 14.48 16.3489C14.8572 16.0689 14.8972 16.4746 14.8972 16.4803C15.0343 16.1031 14.9543 15.8574 14.6743 16.0117Z",
    fill: "url(#paint30_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18283 14.4291C10.3253 14.4291 11.2514 13.503 11.2514 12.3606C11.2514 11.2181 10.3253 10.292 9.18283 10.292C8.04039 10.292 7.11426 11.2181 7.11426 12.3606C7.11426 13.503 8.04039 14.4291 9.18283 14.4291Z",
    fill: "url(#paint31_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2019 13.9831C11.0971 13.4208 11.367 12.2391 10.8047 11.3439C10.2423 10.4486 9.06072 10.1787 8.16545 10.7411C7.27019 11.3034 7.0003 12.485 7.56264 13.3803C8.12498 14.2756 9.30661 14.5454 10.2019 13.9831Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18284 14.2749C10.2401 14.2749 11.0971 13.4178 11.0971 12.3606C11.0971 11.3033 10.2401 10.4463 9.18284 10.4463C8.12561 10.4463 7.26855 11.3033 7.26855 12.3606C7.26855 13.4178 8.12561 14.2749 9.18284 14.2749Z",
    fill: "url(#paint32_radial)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18284 14.2749C10.2401 14.2749 11.0971 13.4178 11.0971 12.3606C11.0971 11.3033 10.2401 10.4463 9.18284 10.4463C8.12561 10.4463 7.26855 11.3033 7.26855 12.3606C7.26855 13.4178 8.12561 14.2749 9.18284 14.2749Z",
    fill: "url(#paint33_radial)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18283 14.4291C10.3253 14.4291 11.2514 13.503 11.2514 12.3606C11.2514 11.2181 10.3253 10.292 9.18283 10.292C8.04039 10.292 7.11426 11.2181 7.11426 12.3606C7.11426 13.503 8.04039 14.4291 9.18283 14.4291Z",
    fill: "url(#paint34_radial)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18295 13.3088C9.70683 13.3088 10.1315 12.8841 10.1315 12.3602C10.1315 11.8363 9.70683 11.4116 9.18295 11.4116C8.65907 11.4116 8.23438 11.8363 8.23438 12.3602C8.23438 12.8841 8.65907 13.3088 9.18295 13.3088Z",
    fill: "url(#paint35_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18294 13.0175C9.55437 13.0175 9.89151 12.8461 10.1029 12.5718C10.0058 12.9946 9.62866 13.3089 9.18294 13.3089C8.73151 13.3089 8.35437 12.9946 8.26294 12.5718C8.48008 12.8403 8.81151 13.0175 9.18294 13.0175Z",
    fill: "url(#paint36_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.5181,
    y1: 12.254,
    x2: 11.1583,
    y2: 21.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3105,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.81496 23.4802) rotate(109.427) scale(6.70966 17.5122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.5376,
    y1: 16.0038,
    x2: 13.8281,
    y2: 4.48873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3105,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A66C3F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6824 16.8831) rotate(1.82138) scale(8.24976 3.76705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11.9361,
    y1: 10.4008,
    x2: 15.828,
    y2: 3.78446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3105,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A66C3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.92459,
    y1: 10.1611,
    x2: 10.6022,
    y2: 20.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3105,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 13.0413,
    y1: 8.2622,
    x2: 11.9214,
    y2: 14.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 6.90152,
    y1: 17.7065,
    x2: 17.4221,
    y2: 8.97969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 6.00933,
    y1: 10.8024,
    x2: 2.53547,
    y2: 21.2932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.57789 10.9294) rotate(28.7804) scale(8.08563 4.3591)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5835 7.57416) rotate(24.6928) scale(5.76666 2.70871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 12.4563,
    y1: 6.63476,
    x2: 14.9028,
    y2: 3.70858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3105,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A66C3F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.05292 1.01604) scale(8.55432 8.58255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1411 8.1947) scale(7.13043 7.15396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.41629 16.0794) rotate(18.9529) scale(7.64085 2.81429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.89202 12.101) rotate(18.953) scale(9.73409 2.95799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.416 15.6095) rotate(-53.3211) scale(4.35568 8.45519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.07455 17.9946) rotate(-76.7811) scale(1.92021 7.16581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5845 16.9563) rotate(179.429) scale(4.84261 1.82615)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7488 11.253) rotate(180) scale(2.05794 2.25024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362501",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362501",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.95 12.6541) scale(2.1689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2A20",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1673,
    stopColor: "#4B3021",
    stopOpacity: 0.5004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7156,
    stopColor: "#734423",
    stopOpacity: 0.8294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824B24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.11986 11.253) rotate(180) scale(2.05794 2.25024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362501",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362501",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.32107 12.6541) scale(2.1689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D2A20",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1673,
    stopColor: "#4B3021",
    stopOpacity: 0.5004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7156,
    stopColor: "#734423",
    stopOpacity: 0.8294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 16.1503,
    y1: 22.088,
    x2: 14.636,
    y2: 11.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8147 12.5924) rotate(90) scale(2.40371 2.433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDCDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    stopColor: "#CFDCDE",
    stopOpacity: 0.8869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8363 12.4916) rotate(180) scale(2.06549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4376,
    stopColor: "#FDFEFE",
    stopOpacity: 0.3499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#F6F8F9",
    stopOpacity: 0.4759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7075,
    stopColor: "#EBEFF0",
    stopOpacity: 0.5657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7983,
    stopColor: "#DAE2E3",
    stopOpacity: 0.6384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8752,
    stopColor: "#C4D1D3",
    stopOpacity: 0.6999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9004,
    stopColor: "#BBCACC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8013 12.3594) rotate(180) scale(2.09951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9161,
    stopColor: "#3C2200",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    stopColor: "#643800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 14.8144,
    y1: 36.4398,
    x2: 14.8144,
    y2: 34.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 14.8144,
    y1: 12.1684,
    x2: 14.8144,
    y2: 13.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 11.9998,
    y1: 18.1114,
    x2: 11.9998,
    y2: 16.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 11.9999,
    y1: 17.3683,
    x2: 11.9999,
    y2: 11.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 10.5212,
    y1: 22.088,
    x2: 9.00695,
    y2: 11.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.18566 12.5924) rotate(90) scale(2.40371 2.433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDCDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    stopColor: "#CFDCDE",
    stopOpacity: 0.8869
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.20727 12.4916) rotate(180) scale(2.06549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4376,
    stopColor: "#FDFEFE",
    stopOpacity: 0.3499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#F6F8F9",
    stopOpacity: 0.4759
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7075,
    stopColor: "#EBEFF0",
    stopOpacity: 0.5657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7983,
    stopColor: "#DAE2E3",
    stopOpacity: 0.6384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8752,
    stopColor: "#C4D1D3",
    stopOpacity: 0.6999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9004,
    stopColor: "#BBCACC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.17223 12.3594) rotate(180) scale(2.09951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9161,
    stopColor: "#3C2200",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    stopColor: "#643800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 9.18558,
    y1: 36.4394,
    x2: 9.18558,
    y2: 34.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 9.18555,
    y1: 12.1684,
    x2: 9.18555,
    y2: 13.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPileOfPoo);
export default __webpack_public_path__ + "static/media/pile-of-poo.54ab58ab3ac4f29f032d4ae649dbf922.svg";
export { ForwardRef as ReactComponent };